import { PlusIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import Input from "../../../../components/input";
import { AllergyCategory } from "../../../../models";
import Container from "../../../../components/container";
import { addAllergy, State } from "../actions/allergy";
import { useActionState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export default function AllergyCreateForm({
  category,
}: {
  category: AllergyCategory;
}) {
  const navigate = useNavigate();    
  const initialState: State = {
    message: null,
    success: false,
    errors: {},
    defaultValues: {
      name: "",
    },
  };

  const [state, formAction, isPending] = useActionState(
    addAllergy,
    initialState
  );
  useEffect(() => {
    if (state.success) {
      navigate(`/admin/allergy-categories/edit/${category.id}?reload=${Date.now()}`);
      toast.success("Allergy added successfully");
    }
  }, [state]);

  return (
    <form action={formAction} className="flex gap-2 w-full ">
      <Input
        className="w-full"
        name="name"
        id="name"
        placeholder="Name"
        required={true}
      ></Input>
      <input
        type="hidden"
        id="allergyCategoryId"
        name="allergyCategoryId"
        value={category.id}
      ></input>
      <IconButton label="Add Allergy" icon={PlusIcon} loading={isPending}></IconButton>
    </form>
  );
}
